var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningFileUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.25L14.5 0.5L28.25 24.25H0.75ZM5.0625 21.75H23.9375L14.5 5.5L5.0625 21.75ZM14.5 20.5C14.8542 20.5 15.1513 20.38 15.3913 20.14C15.6304 19.9008 15.75 19.6042 15.75 19.25C15.75 18.8958 15.6304 18.5992 15.3913 18.36C15.1513 18.12 14.8542 18 14.5 18C14.1458 18 13.8492 18.12 13.61 18.36C13.37 18.5992 13.25 18.8958 13.25 19.25C13.25 19.6042 13.37 19.9008 13.61 20.14C13.8492 20.38 14.1458 20.5 14.5 20.5ZM13.25 16.75H15.75V10.5H13.25V16.75Z",
    fill: "#EF9351"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFileUpload);
export default __webpack_public_path__ + "static/media/warning-file-upload.35c246c97f858053d35c67599f39fe68.svg";
export { ForwardRef as ReactComponent };